import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// Borrador del agente por ticket (autosave). El GET puede devolver { cuerpo: null }
// cuando no hay borrador -> lo normalizamos a cadena vacia para simplificar el
// consumo en el composer. staleTime Infinity: el borrador solo cambia por las
// mutaciones locales (guardar/descartar), que mantienen la cache al dia via
// setQueryData; no tiene sentido revalidarlo contra el servidor.
export const useTicketBorrador = (headquarter, id) =>
  useQuery({
    queryKey: ticketsKeys.borrador(headquarter, id),
    queryFn: async () => {
      const data = await ticketsService.obtenerBorrador({ headquarter, id });
      return data?.cuerpo ?? '';
    },
    enabled: Boolean(headquarter && id),
    staleTime: Infinity,
  });

export const useGuardarBorrador = (headquarter, id) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (cuerpo) => ticketsService.guardarBorrador({ headquarter, id, cuerpo }),
    onSuccess: (_data, cuerpo) => qc.setQueryData(ticketsKeys.borrador(headquarter, id), cuerpo),
  });
};

export const useDescartarBorrador = (headquarter, id) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => ticketsService.descartarBorrador({ headquarter, id }),
    onSuccess: () => qc.setQueryData(ticketsKeys.borrador(headquarter, id), ''),
  });
};
